import { Box, Stack } from "@braintrust/braintrust-ui-components";
import { JobLocationContext } from "@js/apps/jobs/context";
import { NavigateWithSnackbarToastReceiver } from "@js/components/snackbar";

import type { UsePublicJobsListingArg } from "../../hooks/use-public-jobs-listing";
import { usePublicJobsListing } from "../../hooks/use-public-jobs-listing";

import { PublicJobsEmptyState } from "./public-jobs-empty-state";
import { PublicJobsList } from "./public-jobs-list";
import { PublicJobListingFiltersForm } from "./public-jobs-list-filters";
import { PublicJobsLoader } from "./public-jobs-loader";

export type PublicJobsProps = UsePublicJobsListingArg;
export const PublicJobs = (props: PublicJobsProps) => {
  const { jobs, total, openingsCount, loading, isAnyFilterApplied } =
    usePublicJobsListing(props);

  const showJobs = !loading && !!jobs?.length;
  const showEmptyState = !loading && !jobs?.length;

  return (
    <JobLocationContext.Provider
      value={JobLocationContext.Values.public_job_listing}
    >
      <NavigateWithSnackbarToastReceiver />
      <Stack sx={{ maxWidth: "70rem", marginInline: "auto" }}>
        <Box sx={{ mb: 2 }}>
          <PublicJobListingFiltersForm
            openingsCount={openingsCount}
            isAnyFilterApplied={isAnyFilterApplied}
          />
        </Box>
        {loading && <PublicJobsLoader />}
        {showJobs && <PublicJobsList jobs={jobs} total={total} />}
        {showEmptyState && <PublicJobsEmptyState />}
      </Stack>
    </JobLocationContext.Provider>
  );
};
